import { SUBSCRIPTION_STATUSES } from './account.constants';

export const getIsSubscribed = (subStatus) =>
  subStatus === SUBSCRIPTION_STATUSES.subscribed;
export const getIsTrial = (subStatus) =>
  subStatus === SUBSCRIPTION_STATUSES.trial;
export const getIsPreview = (subStatus) =>
  subStatus === SUBSCRIPTION_STATUSES.preview;
export const getIsCancelled = (subStatus) =>
  subStatus === SUBSCRIPTION_STATUSES.cancelled;

export const getSubStatusFlags = (subStatus) => ({
  isSubscribed: getIsSubscribed(subStatus),
  isTrial: getIsTrial(subStatus),
  isPreview: getIsPreview(subStatus),
  isCancelled: getIsCancelled(subStatus)
});

export default {
  getIsSubscribed,
  getIsTrial,
  getIsPreview,
  getIsCancelled,
  getSubStatusFlags
};
